import { FORM_TYPE } from "./applicationLabels";

// Business rule: identity verification (KYC) is required for an owner only when
// they are an authorized user, a control person, or a shareholder holding at
// least this percentage of the business. Shareholders below the threshold
// (e.g. a 10% beneficial owner) do NOT require KYC.
//
// This mirrors the onboarding form rule (see BusinessPlusKYCStatus and
// helperV2.validateControlPersonRules) so the broker portal stays in sync with
// who is actually pulled into the KYC flow. Keep this the single source of truth.
export const KYC_OWNERSHIP_THRESHOLD = 25;

export const isOwnerKycRequired = (person = {}, formType) => {
  // Individual Plus / Prime applications verify the individual applicant.
  if (formType === FORM_TYPE.IndividualPlus || formType === FORM_TYPE.IndividualPrime) {
    return true;
  }
  if (person.isAuthorizedUser === true) return true;
  if (person.isControlPerson === true) return true;
  if (person.isShareHolder === true) {
    return (parseFloat(person.percentOwner) || 0) >= KYC_OWNERSHIP_THRESHOLD;
  }
  return false;
};
